module.exports = __webpack_public_path__ + "img/bgTitle2.4574f327.png";